import React from 'react';

import { useIntl } from 'react-intl';

import AutomationIcon from '@atlaskit/icon/core/automation';
import IconTile from '@atlaskit/icon/icon-tile';

import { useAppearanceForIndex } from '../../../utils/use-random-appearance';

import { messages } from './messages';

export const AutomationBuildTabIcon = ({ index }: { index: number }): React.JSX.Element => {
	const { formatMessage } = useIntl();
	const appearance = useAppearanceForIndex(index, 'AUTOMATION_RULE');

	return (
		<IconTile
			size="small"
			appearance={appearance}
			label={formatMessage(messages.automationRuleIconLabel)}
			icon={() => <AutomationIcon label={formatMessage(messages.automationRuleIconLabel)} />}
		/>
	);
};
